// extracted by mini-css-extract-plugin
export var borderRadius = "_e1-4";
export var large = "_e1-3";
export var logoContainer = "_e1-0";
export var nameLogo = "_e1-2";
export var small = "_e1-1";